import { IAppState } from '../../store';

export const selectReviews = (state: IAppState) => state.reviews;
